<template>
  <div class="wg-row select-chart-container">
    <div class="com-anm22-app-text-xxl">
      {{ $anm22.strLang(lang, 'Payments', 'Pagamenti') }}
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row">
      <div class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'Invoices emitted: ', 'Fatture emesse: ') + chartData.invoiceCount }}
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <a href="https://world.anm22.it/app/pay/invoices.php">
      <div class="wg-row" style="flex-wrap:nowrap;align-items:center;cursor:pointer;">
        <img :src="$anm22.icons.getWorldIcon('vatCode')" class="com-anm22-app-img-fixed-height-l">
        <div class="horizontal-height-div" style="width:10px;"></div>
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'View invoices', 'Visualizza fatture') }}
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    timezone: {
      type: String, 
      default: "Europe/Rome"
    },
    data: {
      type: Object,
      default: () => ({})
    },
    from: String,
    to: String
  },
  data() {
    return {
      chartData: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    start() {
      return this.$moment.tz(this.from, this.timezone).unix();
    },
    end() {
      return this.$moment.tz(this.to, this.timezone).unix();
    },
  },
  created() {
    this.chartData = {
      invoiceCount: this.data.invoices.count
    };
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>

</style>